module.exports = __webpack_public_path__ + "FBD_picture 2.jpg?8a2ef005eacbf94aac36831fee6595bb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/FBD_picture 2.jpg
// module id = 171
// module chunks = 0